import React from 'react';
import PropTypes from 'prop-types';
var AppConfig = require('../../../config.json');

/**
 * A simple OrderFormDataDisplay.
 */

const countries = 
  {
    'DE':'Deutschland',
    'AT':'Österreich',
    'CH':'Schweiz'
};

class OrderFormDataDisplay extends React.Component {
  
    render () {
      const form = this.props.data;
      var street = form.strasse;
      if(form.hausnummer!==street) {
        street = street.concat(" ", form.hausnummer);
      }
        return (
          <div>
          {this.props.type==='personal'?
            <div className={`orderformdatadisplay ${this.props.type}`}>
              <div className="col col_1">
                <div className="name">{form.anrede} {form.vorname} {form.nachname}</div>
                {AppConfig.inputoptions.birthdatecustomer && <div className="geburtstag">geboren am {form.geburtstag}</div>}
                {!this.props.teacher?
                <div>
                  <div className="namekind">Name des Kindes: {form.vornamekind} {form.nachnamekind}</div>
                  <div className="geburtstagkind">Geburtsdatum Kind: {form.geburtstagkind}</div>
                </div>
                :null
                }
              </div>
              <div className="col col_2">
                <div className="strasse">{street}</div>
                <div className="ort">{form.plz} {form.ort}</div>
                <div className="land">{countries[form.land]}</div>
              </div>
              <div className="col col_3">
                <div className="email">{form.email}</div>
                <div className="telefon">{form.fax!==''?"Telefon: ":""}{form.telefon}</div>
                {form.fax!==''?<div className="fax">Fax: {form.fax}</div>:null}
              </div>
            </div>
            :this.props.type==='banking'?
            <div className={`orderformdatadisplay ${this.props.type}`}>
              <div className="col col_1">
                <div className="kontoinhaber"><strong>Kontoinhaber: </strong>{form.kontoinhaber}</div>
                <div className="bank"><strong>Kreditinstitut: </strong>{form.bank}</div>
              </div>
              <div className="col col_2">
                <div className="iban"><strong>IBAN: </strong>{form.iban}</div>
                {form.bic!=='' && 1===0?<div className="bic"><strong>BIC: </strong>{form.bic}</div>:null}
              </div>
            </div>
            :null}

          </div>
        );
    }

}

OrderFormDataDisplay.propTypes = {
  type:PropTypes.string.isRequired,
  /** Button label */
  data: PropTypes.object.isRequired,
  teacher: PropTypes.bool
}


export default OrderFormDataDisplay;





// WEBPACK FOOTER //
// ./src/components/molecules/OrderFormDataDisplay/OrderFormDataDisplay.js